"use client";

import React from "react";
import { CircleCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const benefits = ["Budite profesionalni s najboljim alatima", "Uštedite vrijeme i novac na operacijama", "Poboljšajte produktivnost cijelog tima", "Upravljanje i uvid u stvarnom vremenu"];
export default function SimpleAndClearPricing() {
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="simple-and-clear-pricing" className="py-20 bg-background overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-16 items-center">
          
          {}
          <div ref={imageRef} className={`order-2 md:order-1 transition-all duration-1000 ease-out ${isImageVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
            <div className="relative rounded-xl overflow-hidden shadow-2xl border border-border bg-card">
              <div className="absolute top-0 left-0 right-0 h-8 bg-muted border-b border-border flex items-center px-4 gap-2">
                <div className="w-3 h-3 rounded-lg bg-destructive/80"></div>
                <div className="w-3 h-3 rounded-lg bg-secondary/80"></div>
                <div className="w-3 h-3 rounded-lg bg-primary/80"></div>
              </div>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670497/img/simple_and_clear_pricing.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670497/img/simple_and_clear_pricing.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670497/img/simple_and_clear_pricing.png-wvc-sizes" alt="Dashboard Interface Mockup" className="w-full h-auto object-cover pt-8" loading="lazy" decoding="async" />
            </div>
          </div>

          {}
          <div ref={textRef} className={`order-1 md:order-2 transition-all duration-1000 ease-out delay-200 ${isTextVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-default text-primary mb-6 leading-tight">
              Jednostavne i jasne cijene
            </h2>
            
            <p className="text-lg text-muted-foreground font-default mb-8">
              Otključajte puni potencijal vaše tvrtke s našim sveobuhvatnim setom alata dizajniranih da pojednostave vašem toku rada i povećaju dobit.
            </p>

            <ul className="space-y-4 mb-10">
              {benefits.map((benefit, i) => <li key={i} data-index={i} className="flex items-start gap-3">
                  <CircleCheck className="w-6 h-6 text-primary shrink-0 mt-0.5" />
                  <span className="text-lg text-foreground font-default font-medium">
                    {benefit}
                  </span>
                </li>)}
            </ul>

            <Button variant="secondary" size="lg" asChild>
              
            </Button>
          </div>

        </div>
      </div>
    </section>;
}